import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  Row, Col, Spinner, Button,
  Modal, ModalHeader, ModalBody, ModalFooter,
  Label, FormGroup, Input,
} from 'reactstrap'
import NewLegalEntity from './NewLegalEntity'
import AddFiles from '../Template/Files/AddFiles'
import AddContractFiles from '../Template/Files/AddContractFiles'
import MaskedInput from '../Template/Input/MaskedInput'
import Select from '../Template/Input/Select'
import AsyncSelect from '../Template/Input/AsyncSelect'
import AsyncCreatableSelect from '../Template/Input/AsyncCreatableSelect'
import { notifyError, notifySuccess } from '../../utils/notify'
import oikosApi from '../../services/oikos'
import { getLegalEntities } from '../../store/ducks/comercial'
import pad from '../../utils/number/pad'

class AddDraftContract extends Component {
  constructor(props) {
    super(props)
    this.state = {
      addDraftContractData: {
        contrato_contratante: null,
        contratada: {},
        contratadaAssinantesDiretoria: [],
        firstWitness: {},
        secondWitness: {},
        clientSubscriber: {},
      },
      addDraftContractIsLoading: false,
      addLegalEntityModalIsOpen: false,
    }

    this.contractFileRef = React.createRef()
    this.attachmentsRef = React.createRef()
    this.contratanteRef = React.createRef()
  }

  componentDidMount() {
    const { getLegalEntities } = this.props

    getLegalEntities()
    this.getExistingDraft()
  }

  getExistingDraft = async () => {
    try {
      const addDraftContractData = {
        contrato_contratante: null,
        contratada: {},
        contratadaAssinantesDiretoria: [],
        firstWitness: {},
        secondWitness: {},
        clientSubscriber: {},
      }
      this.setState({ addDraftContractData })
    } catch (err)
    {
      console.log(err);
    }
  }

  handleSubmit = async () => {
    try {
      this.setState({ addDraftContractIsLoading: true })

      const { addDraftContractData } = this.state
      const { addDraftContractPreviousData, toggle } = this.props
      const { files: contractFile } = this.contractFileRef?.current?.state
      const { files: attachmentsFiles } = this.attachmentsRef?.current?.state

      console.tron.log('addDraftContractData', addDraftContractData)
      console.tron.log('contractFile', contractFile)
      console.tron.log('attachmentsFiles', attachmentsFiles)

      if (!addDraftContractData.contrato_contratante) {
        this.setState({ addDraftContractIsLoading: false })
        return notifyError('Preencha o campo "Contratante" antes de continuar.')
      }

      if (!addDraftContractData.contratada?.pj_id) {
        this.setState({ addDraftContractIsLoading: false })
        return notifyError('Preencha o campo "Contratada" antes de continuar.')
      }

      if (!contractFile || contractFile.length <= 0) {
        this.setState({ addDraftContractIsLoading: false })
        return notifyError('Adicione o arquivo da minuta do contrato antes de continuar.')
      }

      // Cria um registro na tabela Minuta
      const minutaBody = {
        action: 'insert',
        table: 'minuta',
        data: {
          minuta_contratante: addDraftContractData.contrato_contratante,
          minuta_contratada: addDraftContractData.contratada.pj_id,
          minuta_contratadaAssina: addDraftContractData.contratadaAssinantesDiretoria?.pf_id || undefined,
          minuta_contratanteAssina: {
            nome: addDraftContractData.clientSubscriber?.pf_nomeExibicao?.pf_nomeExibicao,
            email: addDraftContractData.clientSubscriber?.email,
            cpf: addDraftContractData.clientSubscriber?.cpf,
          },
          minuta_testemunha1: {
            nome: addDraftContractData.firstWitness?.pf_nomeExibicao?.pf_nomeExibicao,
            email: addDraftContractData.firstWitness?.email,
            cpf: addDraftContractData.firstWitness?.cpf,
          },
          minuta_testemunha2: {
            nome: addDraftContractData.secondWitness?.pf_nomeExibicao?.pf_nomeExibicao,
            email: addDraftContractData.secondWitness?.email,
            cpf: addDraftContractData.secondWitness?.cpf,
          },
          //minuta_SPList: addDraftContractPreviousData.webUrl,
          minuta_SPId: addDraftContractPreviousData.SPId,
          minuta_origem: addDraftContractPreviousData.origem,
          prop_nome: addDraftContractPreviousData.nome,
          prop_cod: addDraftContractPreviousData.codigo,
          minuta_aditivo: addDraftContractData.minuta_aditivo,
        },
      }
      console.tron.log('addDraftContract handleSubmit minutaBody', minutaBody)
      const minutaCreated = await oikosApi.post('/', minutaBody)
      console.tron.log('minutaCreated', minutaCreated)

      // Cria um registro na tabela de documentos
      const documentBody = {
        action: 'insert',
        table: 'documento',
        data: {
          tpDocumento_id: 20,
          documento_desc: 'Minuta de Contrato',
          documento_iniVig: undefined,
          documento_fimVig: undefined,
          documento_dtEmissao: undefined,
          documento_prazo: undefined,
          documento_ref: undefined,
          privacidade_id: 2,
        },
      }
      console.tron.log('documentBody', documentBody)
      const documentCreated = await oikosApi.post('/', documentBody)
      console.tron.log('documentCreated', documentCreated)

      // Cria uma vinculação entre a minuta do contrato e a tabela de documentos
      if (documentCreated.data[0].documento_id && minutaCreated.data[0].minuta_id) {
        const vinculationBody = {
          action: 'insert',
          table: 'documentoVinc',
          data: {
            documento_id: documentCreated.data[0].documento_id,
            documentoVinc_tabRef: 'minuta',
            documentoVinc_tabId: minutaCreated.data[0].minuta_id,
          },
        }
        console.tron.log('vinculationBody', vinculationBody)
        const vinculationCreated = await oikosApi.post('/', vinculationBody)
        console.tron.log('vinculationCreated', vinculationCreated)
      }

      // Faz upload do pdf da minuta
      const formData = new FormData()
      formData.append('file', new Blob([contractFile[0].data], { type: contractFile[0].data.type }), contractFile[0].data.path)
      formData.append('table', 'arquivo')
      formData.append('action', 'upload_file')
      formData.append('arquivo_tabRef', 'documento')
      formData.append('arquivo_tabId', documentCreated.data[0].documento_id)
      formData.append('arquivo_privacidade', documentCreated.data[0].privacidade_id)
      formData.append('arquivo_desc', contractFile[0].data.path)

      const res = await oikosApi.post('/', formData)
      console.tron.log('res upload do pdf da minuta', res)

      // Faz upload dos anexos gerais
      if (attachmentsFiles.length > 0) {
        await Promise.all(attachmentsFiles.map(async file => {
          // Cria um registro na tabela de documentos para cada arquivo
          const documentBody = {
            action: 'insert',
            table: 'documento',
            data: {
              tpDocumento_id: file.props?.documentType?.tpDocumento_id,
              documento_desc: file.props?.description,
              documento_iniVig: undefined,
              documento_fimVig: undefined,
              documento_dtEmissao: undefined,
              documento_prazo: undefined,
              documento_ref: undefined,
              privacidade_id: 2,
            },
          }
          const documentCreated = await oikosApi.post('/', documentBody)

          // Cria uma vinculação entre o documento (anexo) e o registro da minuta
          if (documentCreated.data[0].documento_id && minutaCreated.data[0].minuta_id) {
            const vinculationBody = {
              action: 'insert',
              table: 'documentoVinc',
              data: {
                documento_id: documentCreated.data[0].documento_id,
                documentoVinc_tabRef: 'minuta',
                documentoVinc_tabId: minutaCreated.data[0].minuta_id,
              },
            }
            await oikosApi.post('/', vinculationBody)
          }

          // Faz upload do arquivo e registra na tabela 'arquivo'
          const formData = new FormData()
          formData.append('file', new Blob([file.data], { type: file.data.type }), file.data.path)
          formData.append('table', 'arquivo')
          formData.append('action', 'upload_file')
          formData.append('arquivo_tabRef', 'documento')
          formData.append('arquivo_tabId', documentCreated.data[0].documento_id)
          formData.append('arquivo_privacidade', documentCreated.data[0].privacidade_id)
          formData.append('arquivo_desc', file.data.path)
          const fileUploadRes = await oikosApi.post('/', formData)
          console.tron.log('fileUploadRes', fileUploadRes)
        }))
      }
      /*
      // Envia link da minuta para o flow
      const resFlow = await axios.post('https://prod-45.westus.logic.azure.com:443/workflows/598b10455b1a42a49d2ca60637199031/triggers/manual/paths/invoke?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=ctdHixAsX5g37sAgxJUG43Xo7UP8ZNCiKAwj1NW1zwo', {
        cliente: this.props.comercial.legalEntities
          .find(i => i.pj_id === addDraftContractData.contrato_contratante).pj_nomefanta,
        minuta_id: minutaCreated.data[0].minuta_id,
        link: `${process.env.REACT_APP_URL}comercial/contratos/minuta/${minutaCreated.data[0].minuta_id}`,
      })
      console.tron.log('resFlow', resFlow)

      // Salva minuta_flowId na tabela minuta
      const updateBody = {
        action: 'update',
        table: 'minuta',
        data: {
          minuta_id: minutaCreated.data[0].minuta_id,
          minuta_flowId: resFlow.data.minuta_flowId,
        },
      }
      const updateRes = await oikosApi.post('/', updateBody)
      console.tron.log('updateRes', updateRes)


      // Exclui minuta antiga caso rejeitada
      if (
        addDraftContractPreviousData?.draftContract?.minuta_flowStatus === 2
        && addDraftContractPreviousData?.draftContract?.minuta_id
      ) {
        const deleteMinutaBody = {
          action: 'delete',
          table: 'minuta',
          data: {
            minuta_id: addDraftContractPreviousData.draftContract.minuta_id,
          },
        }
        console.tron.log('deleteMinutaBody', deleteMinutaBody)
        const deletedMinutaRes = await oikosApi.post('/', deleteMinutaBody)
        console.tron.log('deletedMinutaRes', deletedMinutaRes)
      }
      */
      this.setState({ addDraftContractIsLoading: false })
      toggle()
      return notifySuccess('Minuta cadastrada com sucesso.')
    } catch (err) {
      this.setState({ addDraftContractIsLoading: false })
      console.tron.log('addDraftContract handleSubmit error: ', err)
      return notifyError('Não foi possível cadastrar a minuta.')
    }
  }

  render() {
    const {
      isOpen, toggle, type, addDraftContractPreviousData,
    } = this.props

    console.log("dados base da minuta: ", addDraftContractPreviousData)

    const {
      addDraftContractData, addDraftContractIsLoading, addLegalEntityModalIsOpen,
    } = this.state

    const {
      getLegalEntitiesIsLoading,
    } = this.props.comercial

    let {
      legalEntities,
    } = this.props.comercial

    legalEntities = legalEntities?.map(i => ({
      value: i.pj_id,
      label: i.pj_nomefanta,
    }))

    console.log('addDraftContractPreviousData', addDraftContractPreviousData)
    console.tron.log('contratante assina', typeof addDraftContractPreviousData?.draftContract?.minuta_contratanteAssina)
    let str_aux
    if (typeof addDraftContractPreviousData?.draftContract?.minuta_contratanteAssina === 'string') {
      let str_aux = JSON.parse(addDraftContractPreviousData?.draftContract?.minuta_contratanteAssina)
      console.log(str_aux.nome)
    }

    return (
      <>
        <NewLegalEntity
          ref={this.contratanteRef}
          isOpen={addLegalEntityModalIsOpen}
          toggle={id => {
            this.setState({
              addDraftContractData: {
                ...addDraftContractData,
                contrato_contratante: id,
              },
              addLegalEntityModalIsOpen: false,
            })

            this.props.getLegalEntities()
          }}
        />

        <Modal
          size="lg"
          isOpen={isOpen}
        >
          <ModalHeader>
            Cadastrar Minuta de Contrato -
            {type === 'privado'
              ? ` Proposta ${addDraftContractPreviousData?.codigo}`
              : ` Licitação ${addDraftContractPreviousData?.codigo}`}
            { (addDraftContractPreviousData?.minuta_aditivo == 1) ? ` (aditivo)` : ''}
          </ModalHeader>
          <ModalBody>
            {
              addDraftContractPreviousData?.minuta_status === 2
              && (
                <Row className="mb-3">
                  <Col>
                    <span style={{ color: 'red' }}>
                      A minuta anterior foi rejeitada.
                    </span>
                  </Col>
                </Row>
              )
            }

            <Row>
              <Col>
                <Row>
                  <Col>
                    <Label>
                      Contratante
                    </Label>
                  </Col>

                  <Col className="d-flex justify-content-end">
                    <Button
                      size="sm"
                      color="link"
                      className="p-0"
                      style={{ marginBottom: 7 }}
                      onClick={() => this.setState({ addLegalEntityModalIsOpen: true })}
                    >
                      Adicionar
                    </Button>
                  </Col>
                </Row>

                <Select
                  style={{ position: 'relative' }}
                  isClearable
                  isSearchable
                  isDisabled={getLegalEntitiesIsLoading || !legalEntities}
                  isLoading={getLegalEntitiesIsLoading}
                  options={legalEntities?.filter(p => p.value !== 1 && p.value !== 2)}
                  value={legalEntities?.filter(p => p.value === addDraftContractData?.contrato_contratante)}
                  onChange={e => this.setState({
                    addDraftContractData: {
                      ...addDraftContractData,
                      contrato_contratante: e?.value,
                    },
                  })}
                />
              </Col>

              <Col>
                <Label>
                  Contratada
                </Label>
                <AsyncSelect
                  cacheOptions
                  defaultOptions
                  isSearchable={false}
                  isClearable={false}
                  isMulti={false}
                  getOptionValue={option => option.pj_id}
                  getOptionLabel={option => option.pj_nomefanta}
                  value={addDraftContractData.contratada}
                  loadOptions={async () => {
                    try {
                      const res = await oikosApi.get('/', {
                        action: 'get',
                        table: 'pj',
                      })

                      if (addDraftContractData.contratada !== undefined) {
                        this.setState(prevState => ({
                          addDraftContractData: {
                            ...prevState.addDraftContractData,
                            contratada: res.data.find(i => i.pj_id === addDraftContractData.contratada.pj_id),
                          },
                        }))
                      }

                      return res.data.filter(item => item.pj_id === 1 || item.pj_id === 2)
                    } catch (e) {
                      return notifyError(e)
                    }
                  }}
                  onChange={e => this.setState(prevState => ({
                    addDraftContractData: {
                      ...prevState.addDraftContractData,
                      contratada: e,
                    },
                  }))}
                />
              </Col>

              <Col>
                <Label>
                  Quem assina pela contratada
                </Label>
                <AsyncSelect
                  cacheOptions
                  defaultOptions
                  isClearable
                  isSearchable={false}
                  isMulti={false}
                  getOptionValue={option => option.pf_id}
                  getOptionLabel={option => option.pf_nomeExibicao}
                  value={addDraftContractPreviousData.contratadaAssinantesDiretoria || addDraftContractData.contratadaAssinantesDiretoria}
                  loadOptions={async () => {
                    try {
                      const res = await oikosApi.get('/', {
                        action: 'get',
                        table: 'pf',
                      })
/*
                      if (addDraftContractData.contratadaAssinantesDiretoria !== undefined) {
                        this.setState(prevState => ({
                          addDraftContractData: {
                            ...prevState.addDraftContractData,
                            contratadaAssinantesDiretoria: res.data.find(i => i.pf_id === addDraftContractData.contratadaAssinantesDiretoria.pf_id),
                          },
                        }))
                      }
*/
                      return res.data.filter(item => item.pf_id === 1 || item.pf_id === 2 || item.pf_id === 3)
                    } catch (e) {
                      return notifyError(e)
                    }
                  }}
                  onChange={e => this.setState(prevState => ({
                    addDraftContractData: {
                      ...prevState.addDraftContractData,
                      contratadaAssinantesDiretoria: e,
                    },
                  }))}
                />
              </Col>
            </Row>

            <Row className="mt-4">
              <Col xs={12}>
                <Label>
                  Quem assina pela contratante
                </Label>
              </Col>

              <Col xs={12} sm={6} lg={5}>
                <FormGroup>
                  <Label>
                    Nome
                  </Label>

                  <AsyncCreatableSelect
                    cacheOptions
                    isSearchable
                    isClearable
                    isMulti={false}
                    defaultOptions={[]}
                    noOptionsMessage={() => 'Digite para buscar'}
                    loadingMessage={() => 'Carregando...'}
                    formatCreateLabel={userInput => `Adicionar "${userInput}"`}
                    getOptionValue={option => option.pf_id}
                    getOptionLabel={option => option.pf_nomeExibicao}
                    getNewOptionData={(inputValue, optionLabel) => ({
                      pf_id: inputValue,
                      pf_nomeExibicao: optionLabel,
                      __isNew__: true,
                    })}
                    value={str_aux?.nome || addDraftContractData?.clientSubscriber?.pf_nomeExibicao}
                    loadOptions={async query => {
                      try {
                        const res = await oikosApi.get('/', {
                          action: 'get',
                          table: 'pf',
                        })

                        console.tron.log('res', res)

                        const regex = new RegExp(query, 'i')
                        const filtered = res.data.filter(i => regex.test(i.pf_nomeExibicao))
                        return filtered
                      } catch (e) {
                        return console.tron.log('erro ao buscar pf no cadastro de minuta', e)
                      }
                    }}
                    onChange={e => {
                      addDraftContractData.clientSubscriber.pf_nomeExibicao = e || null
                      addDraftContractData.clientSubscriber.email = e?.pf_emailProf || ''
                      addDraftContractData.clientSubscriber.cpf = e?.pf_cpf?.toString() || ''
                      addDraftContractData.clientSubscriber.isAlrealdyCreated = !!e
                      this.setState({ addDraftContractData })
                    }}
                    onCreateOption={e => {
                      addDraftContractData.clientSubscriber.pf_nomeExibicao = {
                        pf_id: e,
                        pf_nomeExibicao: e,
                      }
                      addDraftContractData.clientSubscriber.email = ''
                      addDraftContractData.clientSubscriber.cpf = ''
                      addDraftContractData.clientSubscriber.isAlrealdyCreated = false
                      this.setState({ addDraftContractData })
                    }}
                  />
                </FormGroup>
              </Col>

              <Col xs={12} sm={6} lg={4}>
                <Label>
                  Email
                </Label>
                <Input
                  disabled={addDraftContractData.clientSubscriber?.isAlrealdyCreated}
                  value={addDraftContractData.clientSubscriber?.email}
                  onChange={e => {
                    addDraftContractData.clientSubscriber = {
                      ...addDraftContractData.clientSubscriber,
                      email: e.target.value || null,
                    }
                    return this.setState({ addDraftContractData })
                  }}
                />
              </Col>

              <Col xs={12} sm={6} lg={3}>
                <Label>
                  CPF
                </Label>

                <MaskedInput
                  unmask
                  mask="000.000.000-00"
                  lazy={false}
                  disabled={addDraftContractData.clientSubscriber?.isAlrealdyCreated}
                  value={addDraftContractData.clientSubscriber?.cpf}
                  onAccept={value => {
                    addDraftContractData.clientSubscriber = {
                      ...addDraftContractData.clientSubscriber,
                      cpf: !value
                        ? null
                        : addDraftContractData.clientSubscriber?.isAlrealdyCreated
                          ? pad(value, 11)
                          : value,
                    }
                    return this.setState({ addDraftContractData })
                  }}
                />
              </Col>

            </Row>

            <Row className="mt-2">
              <Col xs={12}>
                <Label>
                  Testemunha 1
                </Label>
              </Col>

              <Col xs={12} sm={6} lg={5}>
                <FormGroup>
                  <Label>
                    Nome
                  </Label>

                  <AsyncCreatableSelect
                    cacheOptions
                    isSearchable
                    isClearable
                    isMulti={false}
                    defaultOptions={[]}
                    noOptionsMessage={() => 'Digite para buscar'}
                    loadingMessage={() => 'Carregando...'}
                    formatCreateLabel={userInput => `Adicionar "${userInput}"`}
                    getOptionValue={option => option.pf_id}
                    getOptionLabel={option => option.pf_nomeExibicao}
                    getNewOptionData={(inputValue, optionLabel) => ({
                      pf_id: inputValue,
                      pf_nomeExibicao: optionLabel,
                      __isNew__: true,
                    })}
                    value={addDraftContractData?.firstWitness?.pf_nomeExibicao}
                    loadOptions={async query => {
                      try {
                        const res = await oikosApi.get('/', {
                          action: 'get',
                          table: 'pf',
                        })

                        console.tron.log('res', res)

                        const regex = new RegExp(query, 'i')
                        const filtered = res.data.filter(i => regex.test(i.pf_nomeExibicao))
                        return filtered
                      } catch (e) {
                        return console.tron.log('erro ao buscar pf no cadastro de minuta', e)
                      }
                    }}
                    onChange={e => {
                      addDraftContractData.firstWitness.pf_nomeExibicao = e || null
                      addDraftContractData.firstWitness.email = e?.pf_emailProf || ''
                      addDraftContractData.firstWitness.cpf = e?.pf_cpf?.toString() || ''
                      addDraftContractData.firstWitness.isAlrealdyCreated = !!e
                      this.setState({ addDraftContractData })
                    }}
                    onCreateOption={e => {
                      addDraftContractData.firstWitness.pf_nomeExibicao = {
                        pf_id: e,
                        pf_nomeExibicao: e,
                      }
                      addDraftContractData.firstWitness.email = ''
                      addDraftContractData.firstWitness.cpf = ''
                      addDraftContractData.firstWitness.isAlrealdyCreated = false
                      this.setState({ addDraftContractData })
                    }}
                  />
                </FormGroup>
              </Col>

              <Col xs={12} sm={6} lg={4}>
                <Label>
                  Email
                </Label>
                <Input
                  disabled={addDraftContractData.firstWitness?.isAlrealdyCreated}
                  value={addDraftContractData.firstWitness?.email}
                  onChange={e => {
                    addDraftContractData.firstWitness = {
                      ...addDraftContractData.firstWitness,
                      email: e.target.value || null,
                    }
                    return this.setState({ addDraftContractData })
                  }}
                />
              </Col>

              <Col xs={12} sm={6} lg={3}>
                <Label>
                  CPF
                </Label>

                <MaskedInput
                  unmask
                  mask="000.000.000-00"
                  lazy={false}
                  disabled={addDraftContractData.firstWitness?.isAlrealdyCreated}
                  value={addDraftContractData.firstWitness?.cpf}
                  onAccept={value => {
                    addDraftContractData.firstWitness = {
                      ...addDraftContractData.firstWitness,
                      cpf: !value
                        ? null
                        : addDraftContractData.firstWitness?.isAlrealdyCreated
                          ? pad(value, 11)
                          : value,
                    }
                    return this.setState({ addDraftContractData })
                  }}
                />
              </Col>
            </Row>

            <Row className="mt-2">
              <Col xs={12}>
                <Label>
                  Testemunha 2
                </Label>
              </Col>

              <Col xs={12} sm={6} lg={5}>
                <FormGroup>
                  <Label>
                    Nome
                  </Label>

                  <AsyncCreatableSelect
                    cacheOptions
                    isSearchable
                    isClearable
                    isMulti={false}
                    defaultOptions={[]}
                    noOptionsMessage={() => 'Digite para buscar'}
                    loadingMessage={() => 'Carregando...'}
                    formatCreateLabel={userInput => `Adicionar "${userInput}"`}
                    getOptionValue={option => option.pf_id}
                    getOptionLabel={option => option.pf_nomeExibicao}
                    getNewOptionData={(inputValue, optionLabel) => ({
                      pf_id: inputValue,
                      pf_nomeExibicao: optionLabel,
                      __isNew__: true,
                    })}
                    value={addDraftContractData?.secondWitness?.pf_nomeExibicao}
                    loadOptions={async query => {
                      try {
                        const res = await oikosApi.get('/', {
                          action: 'get',
                          table: 'pf',
                        })

                        console.tron.log('res', res)

                        const regex = new RegExp(query, 'i')
                        const filtered = res.data.filter(i => regex.test(i.pf_nomeExibicao))
                        return filtered
                      } catch (e) {
                        return console.tron.log('erro ao buscar pf no cadastro de minuta', e)
                      }
                    }}
                    onChange={e => {
                      addDraftContractData.secondWitness.pf_nomeExibicao = e || null
                      addDraftContractData.secondWitness.email = e?.pf_emailProf || ''
                      addDraftContractData.secondWitness.cpf = e?.pf_cpf?.toString() || ''
                      addDraftContractData.secondWitness.isAlrealdyCreated = !!e
                      this.setState({ addDraftContractData })
                    }}
                    onCreateOption={e => {
                      addDraftContractData.secondWitness.pf_nomeExibicao = {
                        pf_id: e,
                        pf_nomeExibicao: e,
                      }
                      addDraftContractData.secondWitness.email = ''
                      addDraftContractData.secondWitness.cpf = ''
                      addDraftContractData.secondWitness.isAlrealdyCreated = false
                      this.setState({ addDraftContractData })
                    }}
                  />
                </FormGroup>
              </Col>

              <Col xs={12} sm={6} lg={4}>
                <Label>
                  Email
                </Label>
                <Input
                  disabled={addDraftContractData.secondWitness?.isAlrealdyCreated}
                  value={addDraftContractData.secondWitness?.email}
                  onChange={e => {
                    addDraftContractData.secondWitness = {
                      ...addDraftContractData.secondWitness,
                      email: e.target.value || null,
                    }
                    return this.setState({ addDraftContractData })
                  }}
                />
              </Col>

              <Col xs={12} sm={6} lg={3}>
                <Label>
                  CPF
                </Label>

                <MaskedInput
                  unmask
                  mask="000.000.000-00"
                  lazy={false}
                  disabled={addDraftContractData.secondWitness?.isAlrealdyCreated}
                  value={addDraftContractData.secondWitness?.cpf}
                  onAccept={value => {
                    addDraftContractData.secondWitness = {
                      ...addDraftContractData.secondWitness,
                      cpf: !value
                        ? null
                        : addDraftContractData.secondWitness?.isAlrealdyCreated
                          ? pad(value, 11)
                          : value,
                    }
                    return this.setState({ addDraftContractData })
                  }}
                />
              </Col>

            </Row>

            <Row className="mt-2">
              <Col>
                <Label>
                  Minuta do contrato
                </Label>
                <AddFiles
                  ref={this.contractFileRef}
                  multiple={false}
                  accept={['.pdf']}
                />
              </Col>
            </Row>

            <Row className="mt-4">
              <Col>
                <Label>
                  Anexos da minuta
                </Label>
                <AddContractFiles
                  ref={this.attachmentsRef}
                />
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              onClick={() => toggle()}
              color="light"
              className="waves-effect"
              disabled={addDraftContractIsLoading}
            >
              Cancelar
            </Button>
            <Button
              type="button"
              color="primary"
              className="waves-effect waves-light"
              onClick={() => this.handleSubmit()}
              disabled={addDraftContractIsLoading}
            >
              Confirmar
              {addDraftContractIsLoading && (
                <Spinner size="sm" className="ml-2" />
              )}
            </Button>
          </ModalFooter>
        </Modal>
      </>
    )
  }
}

const mapStateToProps = state => ({
  comercial: state.comercial,
})
const mapDispatchToProps = dispatch => bindActionCreators({
  getLegalEntities,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(AddDraftContract)
